import { useTheme as d, getSafeGutter as p } from "@bedrock-layout/spacing-constants";
import { forwardRefWithAs as y } from "@bedrock-layout/type-utils";
import g from "react";
const h = y(
  ({ as: o, justify: e, align: t, style: n, gutter: r, ...i }, s) => {
    const l = d(), a = e ? `justify:${e}` : void 0, c = t ? `align:${t}` : void 0, m = [a, c].filter(Boolean).join(" "), u = n ?? {}, f = o ?? "div";
    return /* @__PURE__ */ g.createElement(
      f,
      {
        "data-bedrock-inline-cluster": m,
        ref: s,
        style: {
          ...u,
          "--gutter": p(l, r)
        },
        ...i
      }
    );
  }
);
h.displayName = "InlineCluster";
export {
  h as InlineCluster
};
